<div class="dashboardNewContentContainer">
    <div
        class="workspaceTabContainer"
        style="z-index: 1;"
        cdkDropList
        [cdkDropListData]="dashboardService.dashboards"
        (cdkDropListDropped)="drop($event)"
        >
        <div *ngFor="let dashboard of dashboardService.dashboards; let index = index" class="workspaceTabArea" cdkDrag cdkDragLockAxis="x" [cdkDragData]="dashboard" #tabRef>
            <div class="workspaceTab bg-greekToMe pr-1"  
                [ngClass]="{'expand-tab': isActiveDashboard(dashboard) && isEditingName, active: isActiveDashboard(dashboard)}">
                <!-- Dashboard Name -->
                    <div id="workspaceTab-{{index}}" class="d-flex align-items-center h-100 w-auto workspaceTabLabel" style="flex: 1;" (click)="updateSelectedDashboard(dashboard)" cdkDragHandle>                    
                        <span *ngIf="!isActiveDashboard(dashboard) || !canEditName(dashboard)" [hidden]="isActiveDashboard(dashboard) && canEditName(dashboard)">
                        {{ dashboard?.DashboardName ?? '' }}
                    </span>
 
                     <!-- Edit Dashboard Name From Tab -->
                    <div *ngIf="isActiveDashboard(dashboard) && canEditName(dashboard) && !isNewTab(dashboard)">
                        <span id="edit-tab-name" [hidden]="isEditingName" (dblclick)="editDashboardName(dashboard,index)">
                            {{ getDashboardName(index) }}
                        </span>
 
                        <div *ngIf="isEditingName" class="d-flex">
                            <input #tabNameInput [attr.id]="'tabNameInput-' + index" type="text" class="form-control no-animate-hide" style="max-width: 200px; min-width: 60px" maxlength="50"
                                (blur)="checkEditNameChanges(dashboard, index, $event)" (keypress)="enterPressed(dashboard, index, $event)" [value]="getDashboardName(index)"
                                [(ngModel)]="editName"
                                (click)="$event.stopPropagation()"
                            />
                            <button [attr.id]="'confirmName-' + index" type="button" class="ml-2 icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="checkEditNameChanges(dashboard, index, $event)">
                                <svg class="icon-16 no-animate-hide"><use href="../App_Themes/clearview-default/icons/utility/checkmark.svg#checkmark"></use></svg>
                            </button>
                            <button [attr.id]="'cancelName-' + index" class="icon-btn fill-gray5-w-hover mr-1 ml-auto" type="button" (click)="cancelEditDashboardName(dashboard, index)">
                                <svg class="icon-16 fill-valyrianSteel fill-hover-whaleTail"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
                            </button>
                        </div>
                    </div>
                    <span *ngIf="isNewTab(dashboard)" cvLocalizedText langSection="Left_Nav_Popup" langKey="New_Tab">New Tab</span>
                </div>
 
                <!-- Menu Button -->
                <div class="workspaceTab-button" *ngIf="!isNewTab(dashboard) && availableDashboardLoaded(dashboard)" [hidden]="isEditingName || !dashboard" ngbDropdown container="body">
                    <button type="button" [attr.id]="'workspaceTabMenu-' + index" class="icon-btn fill-valyrianSteel px-1 no-dropdown-caret" ngbDropdownToggle>
                        <svg class="icon-12 fill-hover-black"><use href="../App_Themes/clearview-default/icons/utility/more.svg#more"></use></svg>
                    </button>
 
                    <!-- Menu --> 
                    <div class="dropdown-menu dashboard-tab-menu text-nowrap" ngbDropdownMenu aria-labelledby="simple-dropdown">
                        <div ngbDropdownItem class="p-0" *ngIf="canEditName(dashboard)">
                            <button type="button" [attr.id]="'workspaceTabEdit-' + index" class="btn btn-icon fill-valyrianSteel" (click)="edit(dashboard)">
                                <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/edit.svg#edit"></use></svg>
                                <span cvLocalizedText langSection="Dashboard_Tab" langKey="Edit_Details">Edit Details</span>
                            </button>
                        </div>
                        <div ngbDropdownItem class="position-relative p-0" *ngIf="canSetTimezone(dashboard)">
                            <button type="button" [attr.id]="'workspaceTabTimeZone-' + index" class="btn btn-icon fill-valyrianSteel">
                                <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/time.svg#time"></use></svg>
                                <span cvLocalizedText langSection="Time_Zone" langKey="Time_Zone">Time Zone</span>
                                <svg class="position-absolute mr-2" style="right: 0;"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg>
                            </button>
                            <ul class="dropdown-menu dropdown-submenu">
                                <li [class.languageMenuSelected]="!dashboard.TimeZoneInfoName" >
                                    <button type="button" [attr.id]="'workspaceTabTimeZone-' + index + '-UserDefault'" class="btn btn-icon fill-valyrianSteel"
                                     (click)="setTimezone(dashboard)" [attr.title]="timezoneService.dataObj.selectedTimeZone === 'Not Set' ? timezoneService.dataObj.defaultCompanyTimeZone : timezoneService.dataObj.selectedTimeZone">
                                    <span cvLocalizedText langSection="Controls" langKey="User">User</span>&nbsp;
                                    <span cvLocalizedText langSection="Controls" langKey="Default">Default</span>
                                    </button>
                                </li>
                                <li *ngFor="let timezone of timezoneService.dataObj.availableTimeZones" [class.languageMenuSelected]="dashboard.TimeZoneInfoName === timezone">
                                    <button type="button" [attr.id]="('workspaceTabTimeZone-' + index + '-' + timezone) | cleanId" class="btn btn-icon fill-valyrianSteel"
                                        (click)="setTimezone(dashboard, timezone)" [ngClass]="{languageMenuSelected: dashboard.TimeZoneInfoName === timezone}">
                                        <span>{{timezone}}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div ngbDropdownItem class="p-0" *ngIf="canSubscribe(dashboard)">
                            <button type="button" [attr.id]="'workspaceTabSubscribe-' + index" class="btn btn-icon fill-valyrianSteel" (click)="openScheduler(dashboard)">
                                <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/subscribe.svg#subscribe"></use></svg>
                                <span cvLocalizedText langSection="Common" langKey="Subscribe">Subscribe</span>
                            </button>
                        </div>
                        <div ngbDropdownItem class="p-0" *ngIf="canShare(dashboard)">
                            <button type="button" [attr.id]="'workspaceTabShare-' + index" class="btn btn-icon fill-valyrianSteel" (click)="openAssignTool(dashboard)">
                                <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/share.svg#share"></use></svg>
                                <span cvLocalizedText langSection="Common" langKey="Share">Share</span>
                            </button>
                        </div>
                        <div ngbDropdownItem class="p-0" *ngIf="canShareURL(dashboard)">
                            <button type="button" [attr.id]="'workspaceTabShareURL-' + index" class="btn btn-icon fill-valyrianSteel" (click)="openShareURL(dashboard)">
                                <svg class="icon-12 fill-valyrianSteel"><use href="../App_Themes/clearview-default/icons/utility/link.svg#link"></use></svg>
                                <span cvLocalizedText langSection="Dashboard_Tab" langKey="ShareURL">Share URL</span>
                            </button>
                        </div>
                        <div ngbDropdownItem class="p-0" *ngIf="canFilter(dashboard)">
                            <button type="button" [attr.id]="'workspaceTabFilter-' + index" class="btn btn-icon fill-valyrianSteel" style="white-space: nowrap;" (click)="openFilter(dashboard)">
                                <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/filter.svg#filter"></use></svg>
                                <span cvLocalizedText langSection="Dashboard_Tab" langKey="Dashboard_Filter">Dashboard Filter</span>
                            </button>
                        </div>
                        <div ngbDropdownItem class="p-0" *ngIf="hasCreatePermission()">
                            <button type="button" [attr.id]="'workspaceTabCopy-' + index" class="btn btn-icon fill-valyrianSteel" (click)="copy(dashboard)">
                                <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/copy.svg#copy"></use></svg>
                                <span cvLocalizedText langSection="Common" langKey="Copy">Copy</span>
                            </button>
                        </div>
                        <div ngbDropdownItem class="p-0 position-relative" *ngIf="canExport(dashboard)">
                            <button type="button" [attr.id]="'workspaceTabExport-' + index" class="btn btn-icon fill-valyrianSteel">
                                <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/export.svg#export"></use></svg>
                                <span cvLocalizedText langSection="Module_Menu" langKey="Export">Export</span>
                                <svg class="position-absolute mr-2" style="right: 0;"><use href="../App_Themes/clearview-default/icons/utility/arrow-right.svg#arrow-right"></use></svg>
                            </button>
                            <ul class="dropdown-menu dropdown-submenu">
                                <li>
                                    <button type="button" [attr.id]="'workspaceTabExport-' + index + '-Excel'" class="btn btn-icon fill-valyrianSteel" (click)="export(dashboard, 'excel')">
                                        <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/excel-objectives.svg#excel-objectives"></use></svg>
                                        <span cvLocalizedText langSection="Modules" langKey="Excel_with_Objectives">Excel with Objectives</span>
                                    </button>
                                </li>
                                <li>
                                    <button type="button" [attr.id]="'workspaceTabExport-' + index + '-Excel_No_Objectives'" class="btn btn-icon fill-valyrianSteel" (click)="export(dashboard, 'excelNoObjectives')">
                                        <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/excel.svg#excel"></use></svg>
                                        <span cvLocalizedText langSection="Modules" langKey="Excel">Excel</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div ngbDropdownItem class="p-0">
                            <button type="button" [attr.id]="'workspaceTabFullScreen-' + index" class="btn btn-icon fill-valyrianSteel" (click)="requestFullscreen(dashboard)">
                                <svg class="mr-2"><use href="../App_Themes/clearview-default/icons/utility/expand.svg#expand"></use></svg>
                                <span cvLocalizedText langSection="Dashboard_Tab" langKey="Full_Screen">Full screen</span>
                            </button>
                        </div>
                    </div>
 
                </div>
 
                <!-- Close Button -->
                <button type="button" [attr.id]="'closeWorkspaceTab-' + index" class="workspaceTab-button icon-btn fill-valyrianSteel p-0 ml-1 mr-2"
                    *ngIf="!noOpenTabs()" [hidden]="isEditingName"
                    (click)="closeDashboard(dashboard)"
                >
                    <svg class="icon-12 fill-hover-black"><use href="../App_Themes/clearview-default/icons/utility/close.svg#close"></use></svg>
                </button>
            </div>
            <!-- <div class="workspaceTabDivider" ng-show="$ctrl.showTabDivider(dashboard.DashboardKey)"></div> -->
        </div>
        <div id="workspaceTab-Add" class="workspaceTabAddBtn" [hidden]="!showAddButton()" (click)="newTab()"></div>
    </div>
    <div class="workspaceDashboardsContainer">
        <ng-container *ngIf="dashboardService.workspaceKey !== null">
            <div *ngFor="let dashboard of dashboardService.dashboards">
                <cv-responsive-dashboard
                    *ngIf="dashboard?.DashboardKey"
                    [activeDashboardKey]="activeDashboardKey"
                    [loadActiveDashboard]="true"
                    [hidden]="!isActiveDashboard(dashboard)"
                    class="responsiveDashboard"
                    [dashboardInfo]="dashboard"
                    (updateDashboard)="updateDashboards()"
                ></cv-responsive-dashboard>
                <cv-workspace-new-tab-landing
                    *ngIf="dashboard?.DashboardKey === null"
                    [hidden]="!isActiveDashboard(null)"
                    [workspaceKey]="dashboardService.workspaceKey"
                ></cv-workspace-new-tab-landing>
            </div>
        </ng-container>
    </div>
    <cv-taskbar [hidden]="!showTaskbar()"></cv-taskbar>
</div>
 
<!-- Share Popup -->
<cv-angular-assign-tool
    type='dashboardSharing'
    [headerText]="getLocalizedText('Share_Settings', 'Share Settings')"
    buttonText="Apply"
    [singleAdd]="true" [singleType]="false"
    [(showPopup)]="assignToolOpened"
    [dataTransfer]="dashboardsToAssign"
    (dataTransferChange)="updateDashboardAssignments($event)"
    [useLogins]="true" [showAll]="true">
</cv-angular-assign-tool>
 
<!-- Subscription Popup -->
<cv-subscription-scheduler
    *ngIf="schedulerOpened"
    [reportType]="0"
    (closed)="closeScheduler()"
    [embedMode]="false"
    [subscriptionTitle]="subscriptionTitle"
    [subscriptionId]="subscriptionId"
    [relatedId]="schedulerId"
    [relatedKey]="schedulerKey"
></cv-subscription-scheduler>
 
<!-- Settings Panel -->
<cv-dashboard-filter-slideout
    [(open)]="openSlideout"
    [dashboardManager]="filterDashboardManager"
></cv-dashboard-filter-slideout>

